// extracted by mini-css-extract-plugin
export default {"row":"createCompetition_row__UbXHw","col":"createCompetition_col__9VqVa","card":"createCompetition_card__khAfR"};